jQuery(document).ready(function () {
  const mobileMenu = jQuery('.mobile-menu');
  const closeMenu = jQuery('.nav-close');
  const menuWrapper = jQuery('.menu-wrp');
  const navigation = jQuery('.navi-wrp');
  const closeMobileMenu = function () {
    menuWrapper.removeClass('slide-menu');
    navigation.removeClass('overlay01');
    mobileMenu.attr('aria-expanded', 'false');
  };
  mobileMenu.attr({ role: 'button', tabindex: '0', 'aria-label': 'Open menu', 'aria-expanded': 'false' });
  closeMenu.attr({ role: 'button', tabindex: '0', 'aria-label': 'Close menu' });
  mobileMenu.on('click', function () {
    const isOpen = !menuWrapper.hasClass('slide-menu');
    menuWrapper.toggleClass('slide-menu', isOpen);
    navigation.toggleClass('overlay01', isOpen);
    mobileMenu.attr('aria-expanded', String(isOpen));
  });
  closeMenu.on('click', function () {
    closeMobileMenu();
    mobileMenu.trigger('focus');
  });
  mobileMenu.add(closeMenu).on('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      jQuery(this).trigger('click');
    }
  });
  const dropdowns = jQuery('.main-menu li.menu-item-has-children');
  const updateDropdownState = function () {
    dropdowns.each(function () {
      const item = jQuery(this);
      item.children('button').attr('aria-expanded', String(item.hasClass('open_sub')));
    });
  };
  dropdowns.each(function () {
    const item = jQuery(this);
    const trigger = item.children('button.parent-link');
    jQuery('<button>', {
      type: 'button',
      class: 'dropdownIcon',
      'aria-label': 'Toggle ' + trigger.text().trim() + ' menu',
      'aria-expanded': 'false',
      'aria-controls': trigger.attr('aria-controls'),
      style: 'background:transparent;border:0;color:inherit;cursor:pointer;padding:0;'
    }).append('<i class="fa-solid fa-angle-down" aria-hidden="true"></i>').appendTo(item);
  });
  dropdowns.on('click', 'button.parent-link, button.dropdownIcon', function () {
    const item = jQuery(this).parent();
    item.toggleClass('open_sub').siblings().removeClass('open_sub');
    updateDropdownState();
  });
  jQuery(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
      if (menuWrapper.hasClass('slide-menu')) {
        closeMobileMenu();
        mobileMenu.trigger('focus');
      }
      dropdowns.removeClass('open_sub');
      updateDropdownState();
    }
  });
});
